define('builderShowcaseSectionsUtilsDesktop',[
  'builderShowcaseSectionsUtils',
], () => {
  'use strict';

  const basicLearnMoreButton = document.querySelector('[data-basic-learn-more]');
  function initBasicLearnMoreComponent(event) {
    event.preventDefault();
    basicLearnMoreButton.removeEventListener('click', initBasicLearnMoreComponent);
    require(['basicFormHandler']);
  }

  if (basicLearnMoreButton) {
    basicLearnMoreButton.addEventListener('click', initBasicLearnMoreComponent);
  }
});

